<!-- Modal -->
<div class="modal-box">
   <h2 mat-dialog-title>Share</h2>
   <mat-dialog-content>
      <div class="grid grid-cols-3 gap-3">
         <button mat-stroked-button (click)="open('whatsapp')"><img src="/assets/images/social/whatsapp.png" /></button>
         <button mat-stroked-button (click)="open('telegram')"><img src="/assets/images/social/telegram.png" /></button>
         <button mat-stroked-button (click)="open('facebook')"><img src="/assets/images/social/facebook.png" /></button>
         <button mat-stroked-button (click)="open('twitter')"><img src="/assets/images/social/x.png" /></button>
         <button mat-stroked-button (click)="open('email')"><img src="/assets/images/social/email.png" /></button>
         <button mat-stroked-button
                 [cdkCopyToClipboard]="data.url"
                 (cdkCopyToClipboardCopied)="onCopied($event)">
           Copy Link
         </button>
      </div>
      <p style="margin-top:12px; word-break:break-all">{{ data.url }}</p>
   </mat-dialog-content>
   <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
   </mat-dialog-actions>
</div>